
      import * as Paddle from 'https://cdn.jsdelivr.net/npm/esearch-ocr@5.1.5/dist/esearch-ocr.js';
      // 將 Paddle 掛到全域，供 OCR 模組使用
      // @ts-ignore
      window.Paddle = Paddle;
    